import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

export const FormTextArea = ({ className, dataSpan, hidden, input, label, meta, suffix, textAreaClassName, ...inputProps }) => {
  const { touched, submitFailed, error } = meta;
  const hasError = (touched || submitFailed) && error;
  const tabIndex = hidden || inputProps.disabled || input.readOnly ? -1 : undefined;
  const inputDefaults = { autoComplete: "nope", spellCheck: "default" };
  const fieldClassName = classNames("input__field --text-area", textAreaClassName, { "-suffixed": suffix });

  const inputClassName = classNames("input", className, {
    "--disabled": inputProps.disabled,
    "--error": hasError,
    "--hidden": hidden,
    "--readonly": inputProps.readOnly
  });

  return (
    <fieldset className={inputClassName} data-span={dataSpan}>
      {label && (
        <label htmlFor={input.name} className="input__label">
          {label}
        </label>
      )}

      {hasError && <span className="input__error">*{error}</span>}
      <div className="input__wrapper">
        <textarea id={input.name} className={fieldClassName} tabIndex={tabIndex} {...Object.assign(inputDefaults, inputProps, input)} />
      </div>
    </fieldset>
  );
};

FormTextArea.propTypes = {
  className: PropTypes.string,
  dataSpan: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  hidden: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  readOnly: PropTypes.bool,
  spellCheck: PropTypes.oneOf(["default", "true", "false"]),
  submitFailed: PropTypes.bool,
  suffix: PropTypes.string,
  textAreaClassName: PropTypes.string,
  touched: PropTypes.bool,
  type: PropTypes.string
};

FormTextArea.defaultProps = {
  dataSpan: "1"
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormTextArea.js